import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { PageCrumbs } from '@platform/engine/list/header/PageCrumbs';
import { DeleteModuleButton, isCoreEntity, RecordTypeBuilder } from '@platform/features/workspaces/builder';
import type { ISettingsFieldsPageProps } from './ISettingsFieldsPageProps';

/** Сторінка «Розміщення полів» налаштувань простору (посилання картки «Поля» конструктора). */
const LAYOUT = routes.customize('layout');
/** Модуль, до якого конструктор переходить після видалення модуля (прототип v4 deleteModule: builderMod 'case'). */
const AFTER_DELETE = 'case';

/**
 * «Налаштування модуля › Поля й подання» (прототип v4 page==='builder' з bScoped): смуга крихт, далі колонка, що прокручується разом із
 * шапкою (24px 32px 48px, проміжок 20px): назва модуля з позначкою «Основна сутність» (головна таблиця основного модуля) чи «Власний модуль»,
 * «Налаштування цього модуля: …», «Видалити модуль» (не для основних, isCoreEntity / DeleteModuleButton конструктора) і «Відкрити модуль →»
 * (повернення до модуля, прототип openBMod — page:'module'; дочірня таблиця, окремий модуль прототипу, — її список),
 * далі спільний конструктор типу запису (той самий, що в «Налаштування › Конструктор модулів», без списку модулів; зміни зберігаються
 * перевизначенням простору одразу — ADR-023).
 */
export function SettingsFieldsPage({ ws, module, rt, name, crumbs }: ISettingsFieldsPageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const key = module.module.key;
  return (
    <div className="lv-page">
      <PageCrumbs items={crumbs} />
      <div className="st-bp">
        <div className="st-bp__head">
          <div className="st-bp__titles">
            <div className="st-bp__row">
              <h1 className="st-bp__title">{name}</h1>
              <span className="st-bp__kind">{t(isCoreEntity(module.module, rt) ? 'modSettings.mainEntity' : 'modSettings.customModule')}</span>
            </div>
            <div className="st-bp__sub">{t('pageHead.settingsDesc')}</div>
          </div>
          <div className="st-bp__actions">
            <DeleteModuleButton ws={ws} moduleKey={key} onDeleted={() => navigate(routes.moduleSettings(AFTER_DELETE, 'fields'))} />
            <Link className="st-bp__open" to={rt.main ? routes.moduleReturn(key) : routes.list(key, rt.key)}>{t('pageHead.openModule')}</Link>
          </div>
        </div>
        <RecordTypeBuilder ws={ws} module={module} rtKey={rt.key} layoutTo={LAYOUT} />
      </div>
    </div>
  );
}
